import { Button } from 'antd';
import React from 'react';
import { ButtonGroup } from '@common/components';

export function ExtensionOfferChangeResponseButtons({
  onClick,
}: {
  onClick: (edit: boolean) => void;
}) {
  return (
    <ButtonGroup>
      <Button size="large" onClick={() => onClick(false)}>
        Reject Changes
      </Button>
      <Button size="large" type="primary" onClick={() => onClick(true)}>
        Update Extension Offer
      </Button>
    </ButtonGroup>
  );
}
